import React from 'react'
import Link from 'gatsby-link'

import PageHeader from '../__components/PageHeader'
import PAGE_HEADER from '../img/pageheaders/services_skincare.jpg'

import ShareButtons from '../__components/ShareButtons'

const pageMeta = {
  title: "Skin Care Products",
  desc: '"Clinically proven skin care."'
};
const AboutPage = ({ transition }) => (
  <div style={transition && transition.style} className="page">
    <PageHeader bgPhoto={PAGE_HEADER} contain={true} styles={{ backgroundColor: "#e9e9e9" }} />

    {typeof window !== 'undefined' &&
      <ShareButtons location={location.href} desc={pageMeta.desc} />
    }

    <div className="container">
      <div className="title-bar">
        <h1>{pageMeta.title}</h1>
        <p>{pageMeta.desc}</p>
      </div>

      <p>SkinMedica products are available at Waterview Medical Rejuvenation clinic. From cleansing to sunscreen, we carry most SkinMedica products.
      </p>
      <p>These are high quality, medical grade skin care products that are exclusive to physicians and medical spas.  These products, either used alone or in combination with Botox and Juvederm fillers,  will help you achieve your optimal rejuvenation goals. The doctors will assist you in determining which products are best suited to your personal needs.</p>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/services-skincare-products.js